module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/regenerator/index.js
// module id = 19
// module chunks = 0 1 2 3 5 6 7 8 9 10 11